export const isValidCssNumericValue = (value) => !!value && new RegExp(/^\d+(px|rem|%)$/).test(value);
